// UI texts: the season's story chains (package 4, part I)
export default {
  title: 'Stories',
  all: 'All stories',
  stepOf: 'Step {n} of {total}',
  camp: 'Station 9',
  anyRun: 'any run',
  opensAt: 'Opens at level {n}, with {zone}.',
  count: '{n} of {total}',
  listen: 'Listen to the radio',
  deliver: 'Bring {what}',
  intro: 'Three stories this season, each from its own side: the radio, the hospital and WARDEN. A step comes as its own event on a run in its zone, or waits for you at Station 9. A finished story gives a title, a cosmetic and 5 Relic Shards.',
  done: 'Done',
  who: 'With {who}',
  unknown: '???',
  reward: 'Reward: title {title} · {cosmetic} · {n} Relic Shards',
} as const;
